import { useState } from 'react'
import NavList from './NavList'
import Drawer from '@/components/ui/Drawer/Drawer'
import classNames from '@/utils/classNames'
import useScrollTop from '@/utils/hooks/useScrollTop'
import { TbMenu2 } from 'react-icons/tb'
import type { Mode } from '@/@types/theme'
import UserDropdown from '@/components/template/UserProfileDropdown';
import { useSessionUser } from '@/store/authStore'
import { Link } from '@inertiajs/react'

type NavigationProps = {
    toggleMode: () => void
    mode: Mode
}

const navMenu = [
    {
        title: 'Features',
        value: 'features',
        to: 'otherFeatures',
    },
    {
        title: 'Notes Workspace',
        value: 'application',
        href: '/app',
    },
  // Changelog
]

const Navigation = ({ toggleMode }: NavigationProps) => {
    const { isSticky } = useScrollTop()
    const [isOpen, setIsOpen] = useState(false)
    const { session } = useSessionUser()

    const openDrawer = () => {
        setIsOpen(true)
    }

    const onDrawerClose = () => {
        setIsOpen(false)
    }

    return (
        <div
            style={{ transition: 'all 0.2s ease-in-out' }}
            className={classNames(
                'w-full fixed inset-x-0 z-[50]',
                isSticky ? 'top-4' : 'top-0',
            )}
        >
            <div
                className={classNames(
                    'flex flex-row self-start items-center justify-between py-3 max-w-7xl mx-auto px-4 rounded-xl relative z-[60] w-full transition duration-200',
                    isSticky
                        ? 'bg-white dark:bg-gray-800 shadow-lg'
                        : 'bg-transparent dark:bg-transparent',
                )}
            >
                <button
                    className="flex lg:hidden items-center gap-4"
                    onClick={openDrawer}
                >
                    <TbMenu2 size={24} />
                </button>
                <Drawer
                    title="Navigation"
                    isOpen={isOpen}
                    width={250}
                    placement="left"
                    onClose={onDrawerClose}
                    onRequestClose={onDrawerClose}
                >
                    <div className="flex flex-col gap-4">
                        <NavList tabs={navMenu} onTabClick={onDrawerClose} />
                    </div>
                </Drawer>
                <a href="/" className="group flex items-center gap-2">
                    <img
                        src="/logo.svg"
                        width={50}
                        height={20}
                        alt="MemoSlate Logo"
                    />
                    {/* Brand name styling: render as single token (no space) with gradient on Slate */}
                    <span
                        className="inline-flex items-baseline leading-none select-none whitespace-nowrap tracking-tight"
                        aria-label="MemoSlate"
                    >
                        <span className="font-extrabold text-xl sm:text-2xl text-primary dark:text-white transition-colors">
                            Memo
                        </span>
                        <span className="font-extrabold text-xl sm:text-2xl bg-gradient-to-r from-primary to-rose-500 bg-clip-text text-transparent transition-colors">
                            Slate
                        </span>
                    </span>
                </a>
                <div className="lg:flex flex-row flex-1 hidden items-end justify-end text-sm text-zinc-600 font-medium hover:text-zinc-800 transition duration-200 [perspective:1000px] overflow-auto sm:overflow-visible no-visible-scrollbar">
                    <NavList tabs={navMenu} />
                </div>
                <div className="flex items-center gap-2">
                    {/*<button*/}
                    {/*    className="relative flex cursor-pointer items-center justify-center rounded-xl p-2 text-neutral-500 hover:shadow-input dark:text-neutral-500"*/}
                    {/*    onClick={toggleMode}*/}
                    {/*>*/}
                    {/*    <svg*/}
                    {/*        className="lucide lucide-sun rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0"*/}
                    {/*        fill="none"*/}
                    {/*        height="16"*/}
                    {/*        stroke="currentColor"*/}
                    {/*        strokeLinecap="round"*/}
                    {/*        strokeLinejoin="round"*/}
                    {/*        strokeWidth="2"*/}
                    {/*        viewBox="0 0 24 24"*/}
                    {/*        width="16"*/}
                    {/*        xmlns="http://www.w3.org/2000/svg"*/}
                    {/*    >*/}
                    {/*        <circle cx="12" cy="12" r="4" />*/}
                    {/*        <path d="M12 2v2" />*/}
                    {/*        <path d="M12 20v2" />*/}
                    {/*        <path d="m4.93 4.93 1.41 1.41" />*/}
                    {/*        <path d="m17.66 17.66 1.41 1.41" />*/}
                    {/*        <path d="M2 12h2" />*/}
                    {/*        <path d="M20 12h2" />*/}
                    {/*        <path d="m6.34 17.66-1.41 1.41" />*/}
                    {/*        <path d="m19.07 4.93-1.41 1.41" />*/}
                    {/*    </svg>*/}
                    {/*    <svg*/}
                    {/*        className="lucide lucide-moon absolute rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100"*/}
                    {/*        fill="none"*/}
                    {/*        height="16"*/}
                    {/*        stroke="currentColor"*/}
                    {/*        strokeLinecap="round"*/}
                    {/*        strokeLinejoin="round"*/}
                    {/*        strokeWidth="2"*/}
                    {/*        viewBox="0 0 24 24"*/}
                    {/*        width="16"*/}
                    {/*        xmlns="http://www.w3.org/2000/svg"*/}
                    {/*    >*/}
                    {/*        <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" />*/}
                    {/*    </svg>*/}
                    {/*    <span className="sr-only">Toggle theme</span>*/}
                    {/*</button>*/}
                    <div className="hidden lg:flex justify-center gap-2 py-1 px-2">
                        {!session.signedIn && (
                            <>
                                <Link
                                    href="/login"
                                    className="heading-text text-sm font-normal px-3 py-1"
                                >
                                    Sign In
                                </Link>
                                {/* TODO: confirm canonical early-access signup route (currently /register) */}
                                <Link
                                    href="/register"
                                    className="button bg-primary hover:bg-primary-mild text-neutral border border-gray-300 dark:bg-gray-700 dark:border-gray-700 ring-primary dark:ring-white hover:border-primary dark:hover:border-white hover:ring-1 hover:text-white dark:hover:text-white dark:hover:bg-transparent text-gray-600 dark:text-gray-100 h-8 rounded-lg px-3 py-1 ms-2 text-sm font-normal"
                                >
                                    Start free
                                </Link>
                            </>
                        )}
                        {session.signedIn && <UserDropdown />}
                    </div>
                    {/* Show UserDropdown on mobile when signed in */}
                    {session.signedIn && (
                        <div className="lg:hidden flex items-center">
                            <UserDropdown />
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Navigation
